import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userId: "",
    userName: "",
    userEmail: "",
    userPhone: "",
    userAddress: "",
    userCity: "",
    userState: "",
    userAvatar: "",

};

const UserSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserId(state, action) {
            // console.log("setTotalCarts action called with payload:", action.payload);
            state.userId = action.payload;
        },
        setUserName(state, action) {
            state.userName = action.payload;

        },
        setUserEmail(state, action) {
            state.userEmail = action.payload;

        },
        setUserPhone(state, action) {
            state.userPhone = action.payload;
        },
        setUserAddress(state, action) {
            state.userAddress = action.payload;
        },
        setUserCity(state, action) {
            state.userCity = action.payload;
        },
        setUserState(state, action) {
            state.userState = action.payload;
        },
        setUserAvatar(state, action) {
            state.userAvatar = action.payload;
        },


    },
});

export const { setUserAvatar, setUserId, setUserName, setUserEmail, setUserPhone, setUserAddress, setUserCity, setUserState
} = UserSlice.actions; // <--- corrected export
export default UserSlice.reducer;


